<template>
  <div class="PagesCrud d-flex">
    <transition name="fade-trans" mode="out-in">
      <CrudList v-if='!selected' key='content'
        form-input-placeholder="Zoek blokken..."
        title-empty-placeholder="Er zijn geen pagina's"

        label="Pagina titel"
        edit-title="Pagina aanpassen"
        add-title="Pagina toevoegen"
        type="page"

        actionTitle="Content toevoegen"
        :cached="true"

        add-success-message="Nieuwe pagina succesvol toegevoegd!"
        edit-success-message="Pagina succesvol bewerkt!"
        :selectable="false"

        v-bind="$attrs"

        @action='item => selected = item'
        @on-fetch="onFetch"
      />
      <div v-else key='content-editor' class="content-editor">
        <div class='flex-column'>
          <div class="p-2">
            <span class="go-back mb-2" @click="selected = null">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd" />
              </svg>
              Back
            </span>
            <div class="p-1">
              For advanced use, please check the docs: <a href="https://tailwindcss.com/docs/typography-plugin" target="_blank">Tailwind typography</a>.
            </div>
          </div>
          
          <div class="textarea">
            <textarea
              @scroll="scroll"
              v-model="content[selectedLang]"

              class="language-markup"
              ref='textarea'
              contenteditable="true"
              :style="{height}"
            ></textarea>
            <div class="preview language-markup" ref="preview" :style="{height}"><span v-html="preview"></span></div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>

import CrudList from "./CrudList.vue"

export default {
  components: {
    CrudList,
  },
  props: {
    selectedLang: String,
  },
  data() {
    return {
      selected: null,
      content: {},
      preview: "",
      loadingContent: true,
      height: null,
      item: null,
    }
  },
  beforeDestroy() {
    this.$emit('remove-on-save', this.onSave)

    this.$emit("config", {
      event_bus: {
        view: null,
        html_content: "",
      },
    })
  },
  methods: {
    scroll(evt) {
      this.$refs.preview.scrollTop = this.$refs.textarea.scrollTop
    },
    async onFetch(result) {
      result.forEach(item => this.fetchPageData(item.uid))
    },
    async fetchPageData(page_id) {
      return (await this.$store.dispatch("cachedGet", {
        endpoint: `/api/websites/${this.$route.params.id}/pages/${page_id}`,
        timeout: 1000 * 30 // 30 seconds
      })).data
    },
    async onSave() {
      const replacedContent = {}
      Object.keys(this.content).forEach(key => {
        replacedContent[key] = (this.content[key] || "").replace(/\'/g, "&#145")
      })
      
      const { data } = await this.axios.put(`/api/websites/${this.$route.params.id}/pages/${this.selected.uid}`, {
        name: this.item.name,
        type: this.item.type,
        content: JSON.stringify(replacedContent),
      })
    },
    async loadPageContent() {
      this.loadingContent = true
      
      const data = await this.fetchPageData(this.selected.uid)
      this.item = data
      if (data.content) this.content = JSON.parse(data.content)

      this.loadingContent = false
    },
    updatePreview(content = this.content) {
      content = content[this.selectedLang] || ""
      this.preview = Prism.highlight(content, Prism.languages.html, 'html')
      this.$emit("config", {
        event_bus: {
          view: 'pages-cms',
          html_content: content,
        },
      })
    },
  },
  watch: {
    content: {
      handler(content) {
        this.updatePreview(content)
      },
      deep: true,
    },
    selectedLang() {
      this.updatePreview()
    },
    async selected(val) {
      if (val) {
        await this.loadPageContent(val)

        this.$emit('on-save', this.onSave)
        this.height = this.$refs.textarea.getBoundingClientRect().height + 'px'
      } else {
        this.$emit('remove-on-save', this.onSave)
      }
    },
  },
}

</script>

<style scoped>

.PagesCrud, .PagesCrud > div, .content-editor > div {
  display: flex;
  flex-basis: 100%;
  width: 100%;
}

.go-back {
  display: block;
  cursor: pointer;
}

.go-back:hover {
  filter: brightness(1.1);
}

.textarea {
  position: relative;
  flex-grow: 1;
}

.language-markup {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;

  border: none !important;
  border-top: 1px solid rgb(225,225,225) !important;
  outline: 0;
  background-color: #1e293b;
  line-height: 1.75;
  padding: 12px;
  color: #1e293b;
  caret-color: #e2e8f0;
  overflow: auto;
  overflow-x: hidden;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  white-space: pre-wrap;
  word-break: break-all;
}

.preview {
  position: absolute;
  color: #e2e8f0;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  pointer-events: none;
  background-color: transparent;
}

</style>
